import React from 'react'
import Contact from './main-page/Contact'

export default function ContactUs() {
  return (
    <div>
      <Contact/>
    </div>
  )
}
